// import axios from "axios";
import React, { useEffect, useState } from "react";
import { CircularProgress, Container, Grid } from "@mui/material";
import FinalPhaseRoutine from "../FinalPhaseRoutine/FinalPhaseRoutine";
// import { Box } from "@mui/system";

const AvailableFinalPhase = () => {
  const [routinedata, setRouineData] = useState([]);

  useEffect(() => {
    fetch("/finalphase.json")
      .then((res) => res.json())
      .then((data) => setRouineData(data));
  }, []);

  return (
    <Container fluid="true" sx={{ margin: "0 auto" }}>
      {routinedata?.length === 0 ? (
        <>
          {" "}
          <CircularProgress
            color="error"
            sx={{
              position: "fixed",
              top: "50%",
              left: "50%",
            }}
          />
          <br />
          <p className="App-logo">Dr. Strange Coming...</p>
        </>
      ) : (
        <Grid container spacing={2} sx={{ margin: "0 0px", mb: "20px" }}>
          {routinedata.map((routine) => (
            <FinalPhaseRoutine routine={routine}></FinalPhaseRoutine>
          ))}
        </Grid>
      )}
    </Container>
  );
};

export default AvailableFinalPhase;
